import React, { useState, useEffect, useRef, useContext } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { srBodyTemplate, CommonBodyForTable, commonFormDialogFooter, DateMonthBodyForTable } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Dialog } from "primereact/dialog";
import { CommonForDetails } from "../CRM/Leads";
import { Toast } from "primereact/toast";
import { failureToast, successToast, exportReport } from "../Common/CommonFunctions";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import { permissionContext } from "../../AppWrapper";
const saved = localStorage.getItem("user");


// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * SalesMembers component to display a list of sales members in a data table.
 * It fetches the sales members data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the sales members based on their names or other attributes.
 */
export const SalesMembers = (props) => {

    const [salesMembersList, setSalesMembersList] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');
    const [editSalesMember, setEditSalesMember] = useState(false);
    const [viewSalesMemberDialog, setViewSalesMemberDialog] = useState(false);
    const [selectedSalesMember, setSelectedSalesMember] = useState(null);
    const [selectedSalesMembersCommision, setSelectedSalesMembersCommision] = useState(null);
    const [aadhaarPhotoFront, setAadhaarPhotoFront] = useState(null);
    const [aadharfrontPreview, setAadharfrontPreview] = useState(null);
    const [aadhaarPhotoBack, setAadhaarPhotoBack] = useState(null);
    const [aadharbackPreview, setAadharbackPreview] = useState(null);
    const [userImage, setUserImage] = useState(null);
    const [userImagePreview, setUserImagePreview] = useState(null);
    const [cancelledCheck, setCancelledCheck] = useState(null);
    const [cancelledCheckPreview, setCancelledCheckPreview] = useState(null);
    const [panPhoto, setPanPhoto] = useState(null);
    const [panPhotoPreview, setPanPhotoPreview] = useState(null);
    const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
    const [commisionDialog, setCommisionDialog] = useState(false)
    const [selectedState, setSelectedState] = useState(null);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [cities, setCities] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState(null);
    const [selectedCity, setSelectedCity] = useState({});
    const [saleMemberFromInfo, setSaleMemberFromInfo] = useState({
        first_name: '',
        last_name: '',
        phone_number: '',
        email_id: '',
        address: '',
        aadharcard_number: '',
        pancard_number: '',
        pincode: '',
        user_type: '',
        status: '',
        level: '',
        prefix: '',
        salesPerson_id: '',
        beneficiary_name: '',
        beneficiary_bank_name: '',
        bank_account_number: '',
        ifsc_code: '',
        account_type: ''
    });

    const [selectedSalesMemberParent, setSelectedSalesMemberParent] = useState(null);
    const [selectedSalesMemberParentID, setSelectedSalesMemberParentID] = useState(null);
    const [levelNames, setLevelNames] = useState([]);

    const rolePermissions = useContext(permissionContext);

    const masterLevelNames = [
        { level: "L1", name: "Associate" },
        { level: "L2", name: "Sr. Associate" },
        { level: "L3", name: "Assistant Sales Manager" },
        { level: "L4", name: "Deputy Sales Manager" },
        { level: "L5", name: "Regional Sales Manager" },
        { level: "L6", name: "General Sales Manager" },
        { level: "L7", name: "Marketing Manager" },
        { level: "L8", name: "Sr. Marketing Manager" },
        { level: "L9", name: "Deputy Marketing Director" },
        { level: "L10", name: "Marketing Director" },
        { level: "L11", name: "Sr. Marketing Director" },
        { level: "L12", name: "Chairman Club Royal 2" },
        { level: "L13", name: "Chairman Club Royal 3" },
        { level: "L14", name: "Chairman Club Royal 4" },
        { level: "L15", name: "Chairman Club Royal 5" },
        { level: "L16", name: "Chairman Club Royal 6" },
        { level: "L17", name: "Chairman Club Royal 7" },
        { level: "L18", name: "Chairman Club Royal - Head" }
    ];

    const prefixOptions = [
        { name: 'Mr.', code: 'mr' },
        { name: 'Ms.', code: 'ms' },
        { name: 'Mrs.', code: 'mrs' }
    ];

    const bankaccounttype = [
        { name: 'Savings Account', code: 'savings' },
        { name: 'Current Account', code: 'current' },
        { name: 'Fixed Deposit', code: 'fd' }
    ];

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);
    const dataRef = useRef(null);

    useEffect(() => {
        debugger
        getSalesMembers(props)
        getStatesData()
    }, [props])

    /** * Function to render the serial number for each row in the data table.
     * It calculates the serial number based on the index of the row in the salesMembersList.
     * @param {Object} rowData - The data of the current row.
     * @return {number} - The serial number for the current row.
     */
    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Sales Members</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>

                </div>
            </span>
        </div>
    )

    /**
     * Function to fetch sales members data from the API
     * and update the state with the fetched data.
     */
    const getSalesMembers = async (data = {}) => {
        setLoading(true)
        let payload = {}
        if (data && data.data && data.data.salesPerson_id) {
            payload.parent_sales_person_id = data.data.salesPerson_id
            console.log(payload);
        }
        const response = await apiServices.getGSFSalesMembers(payload)   // Assuming this API returns the sales members data
        if (response?.data?.response_obj.length > 0) {
            let data = response?.data?.response_obj;
            data = data.map((obj) => ({
                ...obj,
                full_name: obj.first_name + ' ' + obj.last_name
            }));
            setSalesMembersList(data)
        } else {
            setSalesMembersList([])
        }
        setLoading(false)
    }

    const openDeleteDialog = async (data) => {
        setConfirmDeleteDialog(true)
        setSelectedSalesMember(data)
    }

    const openCommisionDialog = async (data) => {
        debugger
        setCommisionDialog(true)
        setSelectedSalesMembersCommision(data)
    }

    const deleteSalesMember = async () => {
        setConfirmDeleteDialog(false)
        // console.log(selectedMachineData);
        const response = await apiServices.deleteSalesMember({ selectedSalesMember })
        if (response?.data?.response_message == 'SUCCESS') {
            successToast(toast, 'Sales Member Deleted Successfully')
            getSalesMembers()
        } else {
            failureToast(toast, 'Failed to Delete')
        }
    }

    const deleteDialogFooter = () => {
        return (
            <>
                <Button label="Yes, Delete it." icon="pi pi-check" className=" p-button-success" onClick={() => { deleteSalesMember() }} />
                <Button label="Cancel" icon="pi pi-times" className=" p-button-danger" onClick={() => { setConfirmDeleteDialog(false) }} />
            </>
        )
    }

    /** * Function to render the action buttons for each row in the data table.
     * It includes Edit and View buttons with appropriate styles and actions.
     * @param {Object} rowData - The data of the current row.
     * @returns JSX element containing action buttons.
     */
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <Button icon="pi pi-eye" title='View Details' className="p-button-rounded p-button-info p-mx-2" aria-label="View Details" onClick={() => { openViewSalesMemberDialog(rowData) }} />
                    {rolePermissions?.editsalesMember && <Button icon="pi pi-pencil" title='Edit' className="p-button-rounded p-button-warning p-mx-2" aria-label="Edit" id={rowData.id} onClick={() => updateSalesMember(rowData)} />}
                    {rolePermissions?.deleteSalesMember && <Button icon="pi pi-trash" title='Delete SalesMember' className="p-button-rounded p-button-danger p-mx-2" aria-label="Delete Order" onClick={() => { openDeleteDialog(rowData) }} />}
                    <Button icon="pi pi-money-bill" title='View Commision' className="p-button-rounded p-button-primary p-mx-2" aria-label="Delete Order" onClick={() => { openCommisionDialog(rowData) }} />
                </div>
            </>
        );
    }

    /** * Function to handle the visibility of the edit sales member dialog.
     * It sets the state to show or hide the dialog based on the parameter passed.
     * @param {boolean} value - The value to set the visibility of the dialog.  
     * 
     */
    const hideEditDialog = () => {
        setEditSalesMember(false);
    }

    /**
     * Function to handle the visibility of the view sales member dialog.
     * It sets the state to show or hide the dialog based on the parameter passed.
     * @param {boolean} value - The value to set the visibility of the dialog.
     */
    const hideviewDialog = () => {
        setViewSalesMemberDialog(false);
    }

    const hideCommisionDialog = () => {
        setCommisionDialog(false);
    }

    /**
     * Function to update the sales member details.
     * It is called when the Save button is clicked in the edit sales member dialog.
     * @param {*} data 
     */
    const updateSalesMember = async (data) => {
        setSaleMemberFromInfo(data);
        // Set the state to show the edit sales member dialog
        setEditSalesMember(true);
    }

    /**
     * Function to open the view sales member dialog.
     * It sets the state to show the dialog for deleting a sales member.
     * @param {*} data 
     */
    const openViewSalesMemberDialog = async (salesMember) => {
        setSelectedSalesMember(null);
        setSelectedSalesMember(salesMember);
        setViewSalesMemberDialog(true);
    }

    /**
     * Function to render the footer of the edit sales member dialog.
     * It includes Cancel and Save buttons with appropriate actions.
     */
    const editSalesMemberFooter = commonFormDialogFooter('Cancel', hideEditDialog, 'Save', 'update-SalesMember-form')

    /**
     * Function to render the footer of the view sales member dialog.
     * It includes Cancel and View buttons with appropriate actions.
     */
    const viewSalesFooter = commonFormDialogFooter('Close', hideviewDialog, 'View', 'view-SalesMember-form')
    const viewSalesFooter2 = commonFormDialogFooter('Close', hideCommisionDialog, 'View', 'view-SalesMember-form')

    /**
     * Function to handle the update of sales members.
     * It is called when the Save button is clicked in the edit sales member dialog.
     * @param {*} e 
     */
    const saveSalesMembers = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Files
        if (aadhaarPhotoFront) formData.append('proof_front', aadhaarPhotoFront);
        if (aadhaarPhotoBack) formData.append('proof_back', aadhaarPhotoBack);
        if (userImage) formData.append('user_image', userImage);
        if (cancelledCheck) formData.append('cancelled_cheque', cancelledCheck);
        if (panPhoto) formData.append('pan_img', panPhoto);

        // Required IDs and details
        formData.append("id", saleMemberFromInfo.id);
        formData.append("IOT_user_id", saleMemberFromInfo.IOT_user_id);
        formData.append("first_name", saleMemberFromInfo.first_name);
        formData.append("last_name", saleMemberFromInfo.last_name);
        formData.append("phone_number", saleMemberFromInfo.phone_number);
        formData.append("email_id", saleMemberFromInfo.email_id);
        formData.append("address", saleMemberFromInfo.address);
        formData.append("aadharcard_number", saleMemberFromInfo.aadharcard_number);
        formData.append("pancard_number", saleMemberFromInfo.pancard_number);
        formData.append("pincode", saleMemberFromInfo.pincode);
        formData.append("user_type", saleMemberFromInfo.user_type);
        formData.append("status", saleMemberFromInfo.status);
        formData.append("level", saleMemberFromInfo.level.level);
        formData.append("prefix", selectedPrefix.name);
        formData.append("city", selectedCity.name);
        formData.append("state", selectedState.name);
        formData.append("salesPerson_id", selectedSalesMemberParentID || saleMemberFromInfo.salesPerson_id);

        setLoading(true);

        try {
            const response = await apiServices.addGSFSalesMembers(formData);
            if (response?.data?.response_message === 'SUCCESS') {
                getSalesMembers();
                hideEditDialog();
                successToast(toast, 'Sales Member Added Successfully');
                setSaleMemberFromInfo({});
            } else {
                failureToast(toast, 'Error adding sales member');
                console.error('Error adding sales member:', response?.data?.message);
            }
        } catch (error) {
            console.error("API Error:", error);
            failureToast(toast, 'Server error while adding sales member');
        }

        setLoading(false);
    };

    // Handle file input changes
    const handleAadhaarPhotoChange = (e) => {
        if (e.target.files && e.target.files[0] && e.target.name == 'aadhaar_photo_front') {
            setAadhaarPhotoFront(e.target.files[0]);
            const previewUrl = URL.createObjectURL(e.target.files[0]);
            setAadharfrontPreview(previewUrl);
        } else if (e.target.files && e.target.files[0] && e.target.name == 'aadhaar_photo_back') {
            setAadhaarPhotoBack(e.target.files[0]);
            const previewUrl = URL.createObjectURL(e.target.files[0]);
            setAadharbackPreview(previewUrl);
        }
    };

    // Handle file input changes for PAN photo
    const handlePanPhotoChange = (e) => {
        setPanPhoto(e.target.files[0]);
        const previewUrl = URL.createObjectURL(e.target.files[0]);
        setPanPhotoPreview(previewUrl);
    };

    // Handle file input changes for cancelled cheque
    const handleCancelledCheckChange = (e) => {
        setCancelledCheck(e.target.files[0]);
        const previewUrl = URL.createObjectURL(e.target.files[0]);
        setCancelledCheckPreview(previewUrl);
    };

    // Handle file input changes for user image
    const handleUserImageChange = (e) => {
        setUserImage(e.target.files[0]);
        const previewUrl = URL.createObjectURL(e.target.files[0]);
        setUserImagePreview(previewUrl);
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Sales Member" icon="pi pi-user-edit" className="p-custom-btn p-ml-2" onClick={() => { setEditSalesMember(true) }} />
            </>
        )
    }

    /** * Function to handle changes in the personal information input fields.
     * It updates the personelInformation state with the new input value.
     * @param {Object} e - The event object containing the input field data.
     */
    const changePersonelInformation = (e) => {
        // Update the editedCustomer state with the new input value
        if (e.target.name === 'level') {
            setSaleMemberFromInfo({ ...saleMemberFromInfo, [e.target.name]: e.value });
        } else {
            setSaleMemberFromInfo({ ...saleMemberFromInfo, [e.target.name]: e.target.value });
        }
    }

    /** * Function to handle changes in the input fields of the customer form.
     * It updates the state with the new input value and handles country, state, and city selections.
     * @param {Object} e - The event object containing the input field data.
     */
    const changeInputs = async (e) => {
        // Update the editedCustomer state with the new input value
        if (e.target.name == 'country') {
            setSelectedCountry(e.value)
            // e.target.id == 'country1' ? setBillingDetails({ ...billingDetails, country: e.value.name }) : setShippingDetails({ ...shippingDetails, country: e.value.name });
            const state = await getStates({ country_id: e.value.id })
            setStates(state)
            setSelectedCity(null)
            setSelectedState(null)
            setCities(null)
            setSelectedCountry(e.value)

        }

        if (e.target.name == 'state') {
            setSelectedState(e.value)
            // e.target.id == 'state1' ? setBillingDetails({ ...billingDetails, state: e.value.name }) : setShippingDetails({ ...shippingDetails, state: e.value.name });
            const city = await getCities({ state_id: e.value.id })
            setCities(city)
            setSelectedState(e.value)

        }

        if (e.target.name == 'city') {
            // e.target.id == 'city1' ? setBillingDetails({ ...billingDetails, city: e.value.name }) : setShippingDetails({ ...shippingDetails, city: e.value.name });
            setSelectedCity(e.value)
        }

        // setEditedCustomer({ ...editedCustomer, [e.target.name]: e.target.value })
    }

    /** * Function to fetch states and cities based on the selected country.
     * It updates the states and cities state variables accordingly.
     */
    const getStatesData = async (data) => {
        // console.log(data);
        getCountry();
        const state = await getStates({ country_id: '101' })
        setStates(state)
        const defaultState = state.filter((x) => { return (x.name == data?.state?.name) });
        if (defaultState?.length > 0) {
            setSelectedState(defaultState[0])
            const city = await getCities({ state_id: defaultState[0].id })
            setCities(city)
            const defaultCity = city.filter((x) => { return (x.name == data?.city?.name) });
            setSelectedCity(defaultCity?.length > 0 ? defaultCity[0] : null)
        }
    }

    /** * Function to fetch states from the API based on the selected country.
     * It returns the list of states.
     * @param {Object} data - The data object containing the country ID.
     * @returns {Array} - The list of states.
     * */
    const getStates = async (data) => {
        const response = await apiServices.getState(data);
        return response?.data;
    }

    /** * Function to fetch countries from the API.
     * It updates the countries state variable with the fetched data.
     */
    const getCountry = async () => {
        const response = await apiServices.getCountry();
        setCountries(response?.data)
    }

    /** * Function to fetch cities based on the selected state.
     * It returns the list of cities.
     * @param {Object} data - The data object containing the state ID.
     * @returns {Array} - The list of cities.
     */
    const getCities = async (data) => {
        const response = await apiServices.getCity(data);
        return response?.data;
    }

    const onChangesalesMember = async (salesPerson) => {
        console.log(salesPerson);
        setSelectedSalesMemberParent(salesPerson.value);
        setSelectedSalesMemberParentID(salesPerson.value.salesPerson_id);
        let result = await getSalesPersonLevel(salesPerson.value);
        debugger
        setLevelNames(result.levels.map(item => ({
            ...item,
            label: `${item.level} - ${item.name}`
        })));
    };

    async function getSalesPersonLevel(selectedSalesMember) {
        let level = selectedSalesMember.level;
        let teamId = selectedSalesMember.teamId;

        console.log("Level ====>>>", level);

        let num = parseInt(level.substring(1), 10); // e.g., "L11" -> 11
        let levels = [];

        // Always use masterLevelNames (not state)
        if (num > 12) {
            levels = masterLevelNames.filter(l => parseInt(l.level.substring(1), 10) <= 12);
        } else {
            levels = masterLevelNames.filter(l => parseInt(l.level.substring(1), 10) < num);
        }

        let result = {
            teamId,
            levels
        };

        console.log("Result Object ====>>>", result);
        return result;
    }

    const changePin = async (e) => {
        const pin = e.target.value.replace(/\D/g, ''); // only digits
        setSaleMemberFromInfo({ ...saleMemberFromInfo, [e.target.name]: pin });

        if (pin.length === 6 && !isNaN(Number(pin))) {
            try {
                const response = await apiServices.getPincodeDetails(pin);

                if (response?.data[0]?.PostOffice?.length > 0) {
                    const postOffice = response.data[0].PostOffice[0];

                    const countryResult = postOffice.Country;
                    const stateResult = postOffice.State;
                    const cityResult = postOffice.District;
                    const blockResult = postOffice.Block;
                    const divisionResult = postOffice.Division;

                    // ✅ country
                    const defaultCountry = countries.find((x) => x.name === countryResult);
                    if (defaultCountry) {
                        setSelectedCountry(defaultCountry);

                        // ✅ states
                        const res = await apiServices.getState({ country_id: defaultCountry.id });
                        setSelectedState(res?.data);

                        const defaultState = res?.data?.find((x) => x.name === stateResult);
                        if (defaultState) {
                            setSelectedState(defaultState);

                            // ✅ cities
                            const res1 = await apiServices.getCity({ state_id: defaultState.id });
                            setCities(res1.data);

                            const defaultCity = res1?.data?.find(
                                (x) =>
                                    x.name === cityResult ||
                                    x.name === blockResult ||
                                    x.name === divisionResult
                            );
                            if (defaultCity) {
                                setSelectedCity(defaultCity);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching pincode details:", error);
            }
        }
    };


    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center" />
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    <Toolbar className="p-mb-4 p-toolbar" right={rightToolbarTemplate}></Toolbar>
                                    <DataTable ref={dataRef} style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                        value={salesMembersList} dataKey="id" exportFilename={`Sales-Members`}
                                        loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header}>
                                        <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }} exportable={true}></Column>
                                        {/* <Column field="first_name" header="First Name" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="last_name" header="Last Name" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column> */}
                                        <Column field="Full Name" header="SalesPerson Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.last_name || ''}`.trim()} style={{ width: '5rem' }} exportable={true}></Column>
                                        <Column field="IOT_user_id" header="User ID" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="salesPerson_id" header="SalesPeron ID" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column>
                                        <Column field="phone_number" header="Phone Number" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="level" header="Level" sortable body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        {/* <Column field="parent_sales_person_name" header="Parent Name" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column> */}
                                        {/* <Column field="email_id" header="Email" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column> */}
                                        <Column field="parent_sales_person_id" header="Parent SalesPerson ID" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column>
                                        <Column field="status" header="Status" sortable body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        <Column field="payment_status" header="Payment Status" sortable body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        {/* <Column field="team_id" header="Team ID" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column> */}
                                        {/* <Column field="account_type" header="Account Type" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column> */}
                                        <Column field="createdAt" header="Created Date" sortable body={DateMonthBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="action" header="Action" body={actionBodyTemplate} style={{ width: '4rem' }}></Column>
                                    </DataTable>
                                </>
                        }

                        <Dialog visible={editSalesMember} style={{ width: '1000px' }} header={`Update Sales Member`} modal className="p-fluid" footer={editSalesMemberFooter} onHide={hideEditDialog} maximizable={true} blockScroll={true}>
                            <form onSubmit={saveSalesMembers} id="update-SalesMember-form" className="p-fluid">
                                <div className="p-col-12">
                                    <h6>Sales Person</h6>
                                    <hr />
                                </div>
                                <div className="p-col-6">
                                    <div className="p-field">
                                        <label htmlFor="sales_person">Select Sales Person</label>
                                        <Dropdown id='sales_person' value={selectedSalesMemberParent} onChange={onChangesalesMember} options={salesMembersList} optionLabel="full_name" placeholder="Select Sales Member" filter className="p-mr-2 p-p-1 multiselect-custom " />
                                    </div>
                                </div>
                                <hr />
                                <div className='p-grid'>
                                    <div className="p-col-12 p-md-2">
                                        <label htmlFor="prefix">Prefix</label>
                                        <Dropdown id="prefix" name="prefix" value={selectedPrefix} onChange={(e) => setSelectedPrefix(e.value)} options={prefixOptions} optionLabel="name" placeholder="Prefix"
                                            className="multiselect-custom" required />
                                    </div>
                                    <div className="p-col-12 p-md-4">
                                        <label htmlFor="first_name">First Name</label>
                                        <InputText id="first_name" name="first_name" placeholder="First Name" onChange={changePersonelInformation} value={saleMemberFromInfo?.first_name || ''} onKeyPress={(e) => {
                                            if (!/[a-zA-Z]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="last_name">Last Name</label>
                                        <InputText id="last_name" name="last_name" placeholder="Last Name" onChange={changePersonelInformation} value={saleMemberFromInfo?.last_name || ''}
                                            onKeyPress={(e) => {
                                                if (!/[a-zA-Z]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="phone_number">Contact</label>
                                        <InputText id="phone_number" name='phone_number' placeholder='Contact' autoComplete="off" minLength={10} maxLength={10} onChange={changePersonelInformation} value={saleMemberFromInfo?.phone_number || ''} onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="email">Email</label>
                                        <InputText id="email" type='email' name='email_id' placeholder='Email' autoComplete="off" onChange={changePersonelInformation} value={saleMemberFromInfo?.email_id || ''} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="address">Address</label>
                                        <InputText id="address" name="address" onChange={changePersonelInformation} value={saleMemberFromInfo?.address || ''} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="pincode">Pincode</label>
                                        <InputText
                                            id="pincode"
                                            maxLength={6}
                                            name="pincode"
                                            value={saleMemberFromInfo?.pincode || ""}
                                            onChange={changePin}
                                            placeholder="Pincode"
                                            autoComplete="off"
                                            required
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="country1">Country</label>
                                        <Dropdown id="country1" disabled name="country" value={selectedCountry} onChange={changeInputs} autoFocus required options={countries} optionLabel="name" placeholder="Select Country" filter className="multiselect-custom" />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="state1">State</label>
                                        <Dropdown id="state1" disabled name="state" value={selectedState} onChange={changeInputs} autoFocus required options={states} optionLabel="name" placeholder="Select State" filter className="multiselect-custom" />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="city1">City</label>
                                        <Dropdown id="city1" disabled name="city" value={selectedCity} onChange={changeInputs} autoFocus required options={cities} optionLabel="name" placeholder="Select City" filter className="multiselect-custom" />
                                    </div>

                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="aadharcard_number">Aadhar Card Number</label>
                                        <InputText id="aadharcard_number" name="aadharcard_number" minLength={12} maxLength={12} onChange={changePersonelInformation} value={saleMemberFromInfo?.aadharcard_number || ''} onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="pancard_number">Pan Card Number</label>
                                        <InputText id="pancard_number" minLength={10} maxLength={10} name="pancard_number" onChange={(e) => {
                                            const upperCaseValue = e.target.value.toUpperCase();
                                            changePersonelInformation({
                                                target: {
                                                    name: "pancard_number",
                                                    value: upperCaseValue
                                                }
                                            });
                                        }} onKeyPress={(e) => {
                                            if (!/[0-9a-zA-Z]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }} required />
                                    </div>
                                    <div className="p-col-12">
                                        <h6>Network Details</h6>
                                        <hr />
                                    </div>
                                    <div className="p-field p-col-4">
                                        <label htmlFor="level">Select Level</label>
                                        <Dropdown id="level" name="level" value={saleMemberFromInfo.level} onChange={changePersonelInformation} autoFocus required options={levelNames} optionLabel="label" placeholder="Select Level" filter className="multiselect-custom" />
                                    </div>
                                    <div className="p-col-12">
                                        <h6>Bank Details</h6>
                                        <hr />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="beneficiary_name">Beneficiary Name</label>
                                        <InputText id="beneficiary_name" name="beneficiary_name" placeholder="Beneficiary Name" onChange={changePersonelInformation} value={saleMemberFromInfo?.beneficiary_name || ''} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="beneficiary_bank_name">Beneficiary Bank Name</label>
                                        <InputText id="beneficiary_bank_name" name="beneficiary_bank_name" placeholder="Beneficiary Bank Name" onChange={changePersonelInformation} value={saleMemberFromInfo?.beneficiary_bank_name || ''} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="bank_account_number">Bank Account Number</label>
                                        <InputText id="bank_account_number" name="bank_account_number" placeholder="Bank Account Number" onChange={changePersonelInformation} value={saleMemberFromInfo?.bank_account_number || ''} required />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="ifsc_code">Bank IFSC Code</label>
                                        <InputText id="ifsc_code" name="ifsc_code" minLength={11} maxLength={11} placeholder="Bank IFSC Code" onChange={(e) => {
                                            const upperCaseValue = e.target.value.toUpperCase();
                                            changePersonelInformation({
                                                target: {
                                                    name: "ifsc_code",
                                                    value: upperCaseValue
                                                }
                                            });
                                        }} required />
                                    </div>
                                    <div className="p-field p-col-6">
                                        <label htmlFor="account_type">Select Bank Account Type</label>
                                        <Dropdown id="account_type" name="account_type" value={saleMemberFromInfo.account_type} onChange={changePersonelInformation} autoFocus required options={bankaccounttype} optionLabel="name" placeholder="Select Bank Account Type" filter className="multiselect-custom" />
                                    </div>
                                    <div className="p-col-12">
                                        <h6>Documents</h6>
                                        <hr />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="user_image" style={{ marginRight: '10px' }}>User Image</label>
                                        <input
                                            type="file"
                                            id="user_image"
                                            name="user_image"
                                            accept="image/*"
                                            onChange={handleUserImageChange}
                                        />
                                        {userImagePreview && (
                                            <div style={{ marginTop: 8 }}>
                                                <img src={userImagePreview} alt="User" width={100} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="aadhaar_photo_front" style={{ marginRight: '10px' }}>Aadhaar Card Photo (Front)</label>
                                        <input
                                            type="file"
                                            id="aadhaar_photo_front"
                                            name="aadhaar_photo_front"
                                            accept="image/*"
                                            onChange={handleAadhaarPhotoChange}
                                        />
                                        {aadharfrontPreview && (
                                            <div style={{ marginTop: 8 }}>
                                                <img src={aadharfrontPreview} alt="Aadhaar" width={100} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="aadhaar_photo_back" style={{ marginRight: '10px' }}>Aadhaar Card Photo (Back)</label>
                                        <input
                                            type="file"
                                            id="aadhaar_photo_back"
                                            name="aadhaar_photo_back"
                                            accept="image/*"
                                            onChange={handleAadhaarPhotoChange}
                                        />
                                        {aadharbackPreview && (
                                            <div style={{ marginTop: 8 }}>
                                                <img src={aadharbackPreview} alt="Aadhaar" width={100} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="pan_photo" style={{ marginRight: '10px' }}>PAN Card Photo</label>
                                        <input
                                            type="file"
                                            id="pan_photo"
                                            name="pan_photo"
                                            accept="image/*"
                                            onChange={handlePanPhotoChange}
                                        />
                                        {panPhotoPreview && (
                                            <div style={{ marginTop: 8 }}>
                                                <img src={panPhotoPreview} alt="PAN" width={100} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label htmlFor="cancelled_cheque" style={{ marginRight: '10px' }}>Cancelled Cheque</label>
                                        <input
                                            type="file"
                                            id="cancelled_cheque"
                                            name="cancelled_cheque"
                                            accept="image/*"
                                            onChange={handleCancelledCheckChange}
                                        />
                                        {cancelledCheckPreview && (
                                            <div style={{ marginTop: 8 }}>
                                                <img src={cancelledCheckPreview} alt="Cancelled Cheque" width={100} />
                                            </div>
                                        )}
                                    </div>

                                    {/* <div className="p-fluid p-grid" style={{ backgroundColor: "#ffffffff" }}> */}

                                    {/* </div> */}
                                </div>
                            </form>
                        </Dialog>

                        <Dialog visible={viewSalesMemberDialog} style={{ width: '500px' }} header={`View Details`} modal footer={viewSalesFooter} onHide={hideviewDialog}>
                            <div className='p-grid'>
                                <div className="p-col-12">
                                    <div className=" widget-performance">
                                        <div className="content">
                                            <ul>
                                                <div className='p-grid'>
                                                    <CommonForDetails name="First Name" value={selectedSalesMember?.first_name || '-'} />
                                                    <CommonForDetails name="Last Name" value={selectedSalesMember?.last_name || '-'} />
                                                    <CommonForDetails name="Contact" value={selectedSalesMember?.phone_number || '-'} />
                                                    <CommonForDetails name="Address" value={`${selectedSalesMember?.address || '-'}, ${selectedSalesMember?.city || '-'}, ${selectedSalesMember?.state || '-'}`} />
                                                    <CommonForDetails name="Parent Sales Person" value={selectedSalesMember?.parent_sales_person_name || '-'} />
                                                    <CommonForDetails name="Team" value={selectedSalesMember?.team_id || '-'} />
                                                    <CommonForDetails name="Level" value={selectedSalesMember?.level || '-'} />
                                                    <CommonForDetails name="Adhar Card" value={selectedSalesMember?.aadharcard_number || '-'} />
                                                    <CommonForDetails name="Pan Card" value={selectedSalesMember?.pancard_number || '-'} />
                                                    <CommonForDetails name="Zoho ID" value={selectedSalesMember?.salesMember_zohoId || '-'} />
                                                    <CommonForDetails name="User Type" value={selectedSalesMember?.user_type || '-'} />
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog visible={commisionDialog} style={{ width: '500px' }} header={`View Commision`} modal footer={viewSalesFooter2} onHide={hideviewDialog}>
                            <div className='p-grid'>
                                <div className="p-col-12">
                                    <div className=" widget-performance">
                                        <div className="content">
                                            <ul>
                                                <div className='p-grid'>
                                                    <CommonForDetails name="Total" className="p-col-12 p-md-2" value={selectedSalesMembersCommision?.total_commission_amount || '0'} />
                                                    <CommonForDetails name="Pending" className="p-col-12 p-md-2" value={selectedSalesMembersCommision?.total_pending_amount || '0'} />
                                                    <CommonForDetails name="Settled" className="p-col-12 p-md-2" value={selectedSalesMembersCommision?.total_settled_amount || '0'} />
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog visible={confirmDeleteDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteDialogFooter} onHide={(e) => { setConfirmDeleteDialog(false) }}>
                            <div className="confirmation-content">
                                <center>
                                    <i className="pi pi-exclamation-triangle p-error" style={{ fontSize: '4rem' }} /><br /><br />
                                    <b><span>Are you sure you want to delete this sales Member</span></b> <br /><br />
                                </center>
                            </div>
                        </Dialog>

                    </div>
                </div>
            </div >
        </>
    )
}